import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_load_container_unassigned_orders_grid_ComponentContextService } from './FootprintManager.load_container_unassigned_orders_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { LoadContainers_order_date_types_singleComponent } from './LoadContainers.order_date_types_single.component'


interface IFootprintManager_load_container_unassigned_orders_gridComponentEntity {
  OrderId?: number, ShipmentId?: number, Order?: { CancelThresholdDate?: string, CreatedSysDateTime?: string, FulfillmentDate?: string, LookupCode?: string, ModifiedSysDateTime?: string, Notes?: string, OwnerReference?: string, ReadyToExportDate?: string, RequestedDeliveryDate?: string, VendorReference?: string, Status?: { Name?: string }, OrderClass?: { Name?: string }, Project?: { Name?: string, Owner?: { Name?: string } }, PreferredWarehouse?: { Name?: string }, PreferredCarrier?: { Name?: string }, PreferredCarrierServiceType?: { Name?: string } }, Shipment?: { LoadContainerSequence?: number, LookupCode?: string, SealId?: string }}

interface IFootprintManager_load_container_unassigned_orders_gridComponentInParams {
  ownerId?: number, projectId?: number, statusIds?: number[], orderTypeId?: number, warehouseId?: number, loadContainerId?: number, lookupCode?: string}


class FootprintManager_load_container_unassigned_orders_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_load_container_unassigned_orders_gridComponent;
  entity: IFootprintManager_load_container_unassigned_orders_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    LoadSequence_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    Id: null,
    Order: null,
    Shipment: null,
    OrderClassName: null,
    LoadSequence: null,
    OwnerName: null,
    ProjectName: null,
    OwnerReference: null,
    VendorReference: null,
    StatusName: null,
    CreatedDate: null,
    FulfillmentDate: null,
    RequestedDeliveryDate: null,
    notes: null,
    PreferredWarehouseName: null,
    PreferredCarrierName: null,
    PreferredCarrierServiceTypeName: null,
    CancelThresholdDate: null,
    ReadyToExportDate: null,
    ModifiedDate: null,
  }



  constructor(
    grid: FootprintManager_load_container_unassigned_orders_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_load_container_unassigned_orders_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Order = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Order,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Shipment = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Shipment,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.OrderClassName = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.OrderClassName,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.LoadSequence = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.LoadSequence,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['LoadSequence_edit'] as DatexFormControl, null, false, false, '', '', null)
      );
    
    this.cells.OwnerName = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.OwnerName,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ProjectName = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ProjectName,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.OwnerReference = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.OwnerReference,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.VendorReference = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.VendorReference,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.StatusName = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.StatusName,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CreatedDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CreatedDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.FulfillmentDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.FulfillmentDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.RequestedDeliveryDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.RequestedDeliveryDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.PreferredWarehouseName = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PreferredWarehouseName,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.PreferredCarrierName = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PreferredCarrierName,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.PreferredCarrierServiceTypeName = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.PreferredCarrierServiceTypeName,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.CancelThresholdDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.CancelThresholdDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ReadyToExportDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ReadyToExportDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.ModifiedDate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ModifiedDate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_load_container_unassigned_orders_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.OrderId,this.entity.ShipmentId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_load_container_unassigned_orders_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.OrderId,this.entity.ShipmentId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'OrderId',this.entity.OrderId);
    set($resultKey, 'ShipmentId',this.entity.ShipmentId);
    const inParams = {
      $keys:[$resultKey],
      projectId:  $grid.inParams.projectId ,
      orderTypeId:  $grid.inParams.orderTypeId ,
      fromDate:  $grid.filters.date_from.control.value ,
      toDate:  $grid.filters.date_to.control.value ,
      dateType:  $grid.filters.date_type.control.value ,
      statusIds:  $grid.inParams.statusIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      warehouseId:  $grid.inParams.warehouseId ,
      orderIds:  null ,
      ownerId:  $grid.inParams.ownerId ,
    };
    const data = await this.$datasources.LoadContainers.ds_unassigned_orders_shipments_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_load_container_unassigned_orders_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.OrderId?.toString();
    (this.cells.Order.displayControl as TextModel).text = $row.entity.Order?.LookupCode;
    (this.cells.Shipment.displayControl as TextModel).text = $row.entity.Shipment?.LookupCode;
    (this.cells.OrderClassName.displayControl as TextModel).text = $row.entity.Order?.OrderClass?.Name;
    (this.cells.LoadSequence.displayControl as TextModel).text = $row.entity.Shipment?.LoadContainerSequence?.toString();
    (this.cells.LoadSequence.editControl as NumberBoxModel).reset($row.entity.Shipment?.LoadContainerSequence);
    (this.cells.OwnerName.displayControl as TextModel).text = $row.entity.Order?.Project?.Owner?.Name;
    (this.cells.ProjectName.displayControl as TextModel).text = $row.entity.Order?.Project?.Name;
    (this.cells.OwnerReference.displayControl as TextModel).text = $row.entity.Order?.OwnerReference;
    (this.cells.VendorReference.displayControl as TextModel).text = $row.entity.Order?.VendorReference;
    (this.cells.StatusName.displayControl as TextModel).text = $row.entity.Order?.Status?.Name;
    (this.cells.notes.displayControl as TextModel).text = $row.entity.Order?.Notes;
    (this.cells.PreferredWarehouseName.displayControl as TextModel).text = $row.entity.Order?.PreferredWarehouse?.Name;
    (this.cells.PreferredCarrierName.displayControl as TextModel).text = $row.entity.Order?.PreferredCarrier?.Name;
    (this.cells.PreferredCarrierServiceTypeName.displayControl as TextModel).text = $row.entity.Order?.PreferredCarrierServiceType?.Name;
    (this.cells.ModifiedDate.displayControl as TextModel).text = $row.entity.Order?.ModifiedSysDateTime?.toString();

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
      await this.on_line_edit();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $row: FootprintManager_load_container_unassigned_orders_gridComponentRowModel,
  $grid: FootprintManager_load_container_unassigned_orders_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_container_unassigned_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'load_container_unassigned_orders_grid.on_data_loaded');
  //O.Arias - 09/12/2024
  
  //Set Date/Time Formats
  const format = `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  if ($utils.isDefined(format)) {
  
      if ($utils.isDefined($row.entity.Order?.CreatedSysDateTime)) {
          $row.cells.CreatedDate.displayControl.text = $utils.date.format($row.entity.Order?.CreatedSysDateTime, format);
      };
  
      if ($utils.isDefined($row.entity.Order?.FulfillmentDate)) {
          $row.cells.FulfillmentDate.displayControl.text = $utils.date.format($row.entity.Order?.FulfillmentDate, format);
      };
  
      if ($utils.isDefined($row.entity.Order?.RequestedDeliveryDate)) {
          $row.cells.RequestedDeliveryDate.displayControl.text = $utils.date.format($row.entity.Order?.RequestedDeliveryDate, format);
      };
  
      if ($utils.isDefined($row.entity.Order?.CancelThresholdDate)) {
          $row.cells.CancelThresholdDate.displayControl.text = $utils.date.format($row.entity.Order?.CancelThresholdDate, format);
      };
  
      if ($utils.isDefined($row.entity.Order?.ModifiedSysDateTime)) {
          $row.cells.ModifiedDate.displayControl.text = $utils.date.format($row.entity.Order?.ModifiedSysDateTime, format);
      };
  
      if ($utils.isDefined($row.entity.Order?.ReadyToExportDate)) {
          $row.cells.ReadyToExportDate.displayControl.text = $utils.date.format($row.entity.Order?.ReadyToExportDate, format);
      };
  
  };
  
  }
  on_line_edit(event = null) {
    return this.on_line_editInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_line_editInternal(
    $row: FootprintManager_load_container_unassigned_orders_gridComponentRowModel,
  $grid: FootprintManager_load_container_unassigned_orders_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_container_unassigned_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/12/2024
  
  let shipmentId = $row.entity.ShipmentId;
  let shipment_update: boolean = false;
  
  const shipment_payload: any = {};
  
  if ($utils.isDefined(shipmentId)) {
  
      if ($row.cells.LoadSequence.editControl.isChanged) {
          shipment_payload.LoadContainerSequence = $row.cells.LoadSequence.editControl.value;
          shipment_update = true;
      };
  };
  
  if (shipment_update) {
      try {
  
          if ($utils.isDefined(shipment_payload)) {
              await $flows.Utilities.crud_update_flow({
                  entitySet: 'Shipments',
                  id: shipmentId,
                  entity: shipment_payload
              });
          };
  
          await $row.refresh();
      } catch (error) {
          $shell.FootprintManager.showErrorDetails('Save', 'Error on save.', error);
          throw error; // to prevent displayMode 
      };
  };
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => LoadContainers_order_date_types_singleComponent),
  ],
  selector: 'FootprintManager-load_container_unassigned_orders_grid',
  templateUrl: './FootprintManager.load_container_unassigned_orders_grid.component.html'
})
export class FootprintManager_load_container_unassigned_orders_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_load_container_unassigned_orders_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_load_container_unassigned_orders_gridComponentInParams = { ownerId: null, projectId: null, statusIds: [], orderTypeId: null, warehouseId: null, loadContainerId: null, lookupCode: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'ID', false, false, null, false),       Order: new GridHeaderModel(new HeaderStyles(null, null), 'Order', 'Order', false, false, null, false),       Shipment: new GridHeaderModel(new HeaderStyles(null, null), 'Shipment', 'Shipment', false, false, null, false),       OrderClassName: new GridHeaderModel(new HeaderStyles(null, null), 'OrderClassName', 'Order class', false, false, null, false),       LoadSequence: new GridHeaderModel(new HeaderStyles(null, null), 'LoadSequence', 'Load sequence', false, false, null, false),       OwnerName: new GridHeaderModel(new HeaderStyles(null, null), 'OwnerName', 'Owner name', false, false, null, false),       ProjectName: new GridHeaderModel(new HeaderStyles(null, null), 'ProjectName', 'Project name', false, false, null, false),       OwnerReference: new GridHeaderModel(new HeaderStyles(null, null), 'OwnerReference', 'Owner reference', false, false, null, false),       VendorReference: new GridHeaderModel(new HeaderStyles(null, null), 'VendorReference', 'Vendor reference', false, false, null, false),       StatusName: new GridHeaderModel(new HeaderStyles(null, null), 'StatusName', 'Status', false, false, null, false),       CreatedDate: new GridHeaderModel(new HeaderStyles(null, null), 'CreatedDate', 'Created date', false, false, null, false),       FulfillmentDate: new GridHeaderModel(new HeaderStyles(null, null), 'FulfillmentDate', 'Fulfillment date', false, false, null, false),       RequestedDeliveryDate: new GridHeaderModel(new HeaderStyles(null, null), 'RequestedDeliveryDate', 'Requested delivery', false, false, null, false),       notes: new GridHeaderModel(new HeaderStyles(null, null), 'notes', 'Notes', false, false, null, false),       PreferredWarehouseName: new GridHeaderModel(new HeaderStyles(null, null), 'PreferredWarehouseName', 'Warehouse', false, false, null, false),       PreferredCarrierName: new GridHeaderModel(new HeaderStyles(null, null), 'PreferredCarrierName', 'Carrier', false, false, null, false),       PreferredCarrierServiceTypeName: new GridHeaderModel(new HeaderStyles(null, null), 'PreferredCarrierServiceTypeName', 'Service type', false, false, null, false),       CancelThresholdDate: new GridHeaderModel(new HeaderStyles(null, null), 'CancelThresholdDate', 'Cancel threshold', false, false, null, false),       ReadyToExportDate: new GridHeaderModel(new HeaderStyles(null, null), 'ReadyToExportDate', 'Ready to export', false, false, null, false),       ModifiedDate: new GridHeaderModel(new HeaderStyles(null, null), 'ModifiedDate', 'Modified date', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_load_container_unassigned_orders_gridComponentRowModel[] = [];

  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('statusIds') set $inParams_statusIds(value: any) {
    this.inParams['statusIds'] = value;
  }
  get $inParams_statusIds(): any {
    return this.inParams['statusIds'] ;
  }
  @Input('orderTypeId') set $inParams_orderTypeId(value: any) {
    this.inParams['orderTypeId'] = value;
  }
  get $inParams_orderTypeId(): any {
    return this.inParams['orderTypeId'] ;
  }
  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }
  @Input('loadContainerId') set $inParams_loadContainerId(value: any) {
    this.inParams['loadContainerId'] = value;
  }
  get $inParams_loadContainerId(): any {
    return this.inParams['loadContainerId'] ;
  }
  @Input('lookupCode') set $inParams_lookupCode(value: any) {
    this.inParams['lookupCode'] = value;
  }
  get $inParams_lookupCode(): any {
    return this.inParams['lookupCode'] ;
  }

  topToolbar = {
      add: new ToolModel(new ButtonModel('add', new ButtonStyles(['creation'], null), false, false, false, 'Add selected orders', 'icon-ic_fluent_add_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    date_from: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_to: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    date_type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    date_from: new FieldModel(new DateBoxModel(this.formGroup.controls['date_from'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date from', false, false),
    date_to: new FieldModel(new DateBoxModel(this.formGroup.controls['date_to'] as DatexFormControl, null, false, false, 'l, LT', 'datetime', null)
, new ControlContainerStyles(null, null), 'Date to', false, false),
    date_type: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['date_type'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Date type', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_load_container_unassigned_orders_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Unassigned orders for load containers';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      projectId:  $grid.inParams.projectId ,
      orderTypeId:  $grid.inParams.orderTypeId ,
      fromDate:  $grid.filters.date_from.control.value ,
      toDate:  $grid.filters.date_to.control.value ,
      dateType:  $grid.filters.date_type.control.value ,
      statusIds:  $grid.inParams.statusIds ,
      fullTextSearch:  $grid.fullTextSearch ,
      warehouseId:  $grid.inParams.warehouseId ,
      orderIds:  null ,
      ownerId:  $grid.inParams.ownerId ,
    };
    try {
      const data = await this.$datasources.LoadContainers.ds_unassigned_orders_shipments_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_load_container_unassigned_orders_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_load_container_unassigned_orders_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_load_container_unassigned_orders_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_add_order(event = null) {
    return this.on_add_orderInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_add_orderInternal(
    $grid: FootprintManager_load_container_unassigned_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_container_unassigned_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 09/12/2024
  
  const selectedRows = $grid.selectedRows;
  
  if (selectedRows.length === 0) {
      $shell.FootprintManager.openErrorDialog('Error adding orders', 'No orders selected.');
      return;
  } else {
  
      const candidates = [];
      const failures = [];
      const errors = [];
  
      for (const row of selectedRows) {
  
          //No validation needed, we'll populate the candidates right away
  
          candidates.push(row);
  
      };
  
      //No candidate
      if (candidates.length === 0) {
          const title = 'Error adding orders';
          const errorMessage = `Order(s) ${failures.map(c => c.entity.Order?.LookupCode)?.filter((value, index, array) => array.indexOf(value) === index)?.join(',')} cannot be added`;
          const errorList = errors;
          await $shell.FootprintManager.openErrorDialog(title, errorMessage, errorList);
          return;
      } else {
  
          const confirmCandidates = `Order(s) ${candidates.map(c => c.entity.Order?.LookupCode)?.filter((value, index, array) => array.indexOf(value) === index)?.join(',')} - will be added to the load container.`
  
          let confirm = false;
  
  
          if (failures.length >= 1) {
  
              const title = 'Some order(s) cannot be added';
              const message = `Do you still want to continue?\r\n\r\n ${confirmCandidates}\r\n\r\n ${errors.join('\r\n\r\n')}`;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message);
  
          } else {
  
              const title = 'Add the following order(s)';
              const message = confirmCandidates;
              confirm = await $shell.FootprintManager.openConfirmationDialog(title, message, 'Proceed');
          }
  
          if (confirm) {
  
              const candidateSuccess = [];
              const candidateFailures = [];
              const errorMsgList = [];
              const errorMsgListDetails = [];
  
              for (const candidate of candidates) {
                  try {
  
                      const flowParams = {
                          orderId: candidate.entity.OrderId,
                          shipmentId: candidate.entity.ShipmentId,
                          loadContainerId: $grid.inParams.loadContainerId
                      }
  
                      let reasons: string[];
  
                      var result = await $flows.LoadContainers.add_order_flow(flowParams);
                      if ($utils.isDefined(result.result)) {
                          reasons = [result.result];
                      }
  
                      if ($utils.isDefined(reasons)) {
                          candidateFailures.push(candidate);
                          errorMsgList.push(`Order ${candidate.entity.Order?.LookupCode} ${(await $flows.Utilities.grammar_format_string_array_flow({ values: reasons })).formattedValue}`);
                      } else {
                          candidateSuccess.push(candidate);
                      }
  
                  } catch (error) {
                      candidateFailures.push(candidate);
                      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
                      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
                      const errorDescription = `Order ${candidate.entity.Order?.LookupCode} - ${errorMessage}`;
                      errorMsgList.push(errorDescription);
                      errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
                  }
              }
  
              //All succeeded
              if (candidateSuccess.length === candidates.length) {
  
                  const title = 'All order(s) added';
                  const message = `Order(s) ${candidateSuccess.map(c => c.entity.Order?.LookupCode)?.filter((value, index, array) => array.indexOf(value) === index)?.join(',')} added`;
                  await $shell.FootprintManager.openInfoDialog(title, message);
                  await $grid.refresh();
  
              } else {
  
                  //All failures
                  if (candidateFailures.length === candidates.length) {
  
                      const title = 'All order(s) failed to be added';
                      const message = `Order(s) ${candidateFailures.map(c => c.entity.Order?.LookupCode)?.filter((value, index, array) => array.indexOf(value) === index)?.join(',')} could not be added`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
  
                  } else {
  
                      const title = 'Some order(s) could not be added';
                      const success = `Order(s) ${candidateSuccess.map(c => c.entity.Order?.LookupCode)?.filter((value, index, array) => array.indexOf(value) === index)?.join(',')} were added.`;
                      const errors = `The following order(s) could not be added: ${candidateFailures.map(c => c.entity.Order?.LookupCode)?.filter((value, index, array) => array.indexOf(value) === index)?.join(',')}`;
                      const message = `${success} \r\n\r\n${errors}`;
                      await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
                      await $grid.refresh();
  
                  };
              };
          };
      };
  };
  
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_load_container_unassigned_orders_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_load_container_unassigned_orders_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 07/15/2023
  
  if ($utils.isDefined($grid.inParams.lookupCode)) {
      $grid.topToolbar.add.control.label = `Add to load container ${$grid.inParams.lookupCode}`
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
